import {MegaMenuItemSelector, MegaMenuOptions} from "../components/MegaMenuItemSelector";

export type SiteType = "teams" | "communication";
export type TeamTemplate = "standard" | "educationStaff" | "educationProfessionalLearningCommunity";
export type UserAccessLevel = "owner" | "member";
export type GroupAccessLevel = "read" | "edit" | "design" | "full control";
export type DefaultMegaMenuOption = "Communication" | "Collaboration";

export interface CreateSiteFormGroup {
    createSiteFormId?: string;
    groupId: string;
    access: GroupAccessLevel;
    groupDisplayName: string;
}

export interface CreateSiteFormUser {
    createSiteFormId?: string;
    userId: string;
    userDisplayName: string;
    userPrincipalName: string;
    access: UserAccessLevel;
}

export default class CreateSiteForm {

    
    static setDefaultMegaMenuOptionIfExists(form: CreateSiteForm,megaMenuOptions: MegaMenuOptions)
    {
        const dropdownKey = form.siteType === "teams" ? "Collaboration" : "Communication";
        const defaultMegaMenuOption = MegaMenuItemSelector.findMegaMenuOptionByDropdownKey(megaMenuOptions,dropdownKey);
        form.menuListName = defaultMegaMenuOption?.listName;
        form.menuSiteUrl = defaultMegaMenuOption?.sitePathForList;
    }
    
    _requiredProperties: string[] = ["tenantId", "schoolCode", "siteName", "menuListName", "menuSiteUrl", "groups"];

    id?: string;
    siteType: SiteType;
    teamTemplate?: TeamTemplate;
    communicationTemplate?: string;
    tenantId?: string;
    schoolCode?: string;
    siteName?: string;
    menuListName?: string;
    menuSiteUrl?: string;
    groups: CreateSiteFormGroup[];
    users: CreateSiteFormUser[];
    createdByDisplayName?: string;
    createdByUPN?: string;
    bulkCreateSiteFormId?: string;

    createdAt?: Date;
    siteId?: string;
    workloadError: boolean;

    message?: string;

    constructor(siteType: SiteType) {

        this.siteType = siteType;
        if(siteType === "teams")
        {
            this.teamTemplate = "standard";
        }

        this.groups = [];
        this.users = [];
        
        this.workloadError = false;
    }
}

export class CreateSiteTemplate {
    displayName?: string;
    key?: string;
}

